document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".cl-banner.swiper").forEach((el) => {
    new Swiper(el, {
      a11y: true,
      direction: "horizontal",
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
        enabled: true,
      },
      autoplay: {
        delay: 5500,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
    });
  });

  const setupImageAlternation = (container) => {
    const alternatingImages = container.querySelectorAll(
      "img.cl-alternating-img",
    );

    if (alternatingImages) {
      const imagesCount = alternatingImages.length;
      const interval =
        container.querySelector("#cl-alternating-img-container").dataset
          .interval || 2500;
      let currentImage = 0;

      if (imagesCount > 1) {
        setInterval(() => {
          alternatingImages[currentImage].classList.add("tw-hidden");
          currentImage = (currentImage + 1) % imagesCount;
          alternatingImages[currentImage].classList.remove("tw-hidden");
        }, interval);
      }
    }
  };

  document.querySelectorAll(".cl-banner").forEach((clBanner) => {
    const bannerSlides = clBanner.querySelectorAll(".swiper-slide");

    if (bannerSlides && bannerSlides.length > 0) {
      bannerSlides.forEach((slide) => {
        setupImageAlternation(slide);
      });
    } else {
      setupImageAlternation(clBanner);
    }
  });
});
